import {Document} from './document.model';

export class ResponseModel {
    TotalOfDocuments: number;
    Documents: Document[];
}



// WEBPACK FOOTER //
// C:/Users/LenninM/WebstormProjects/NomisignWebApp/src/app/models/response.model.ts